import React, {useEffect, useState, useCallback} from 'react';
import { useSelector } from 'react-redux';
import Spinner from '../components/Spinner';


const BuySellTrends = () => {
  
  const { symbolIcons, initialPrices, prices, finishedLoad } = useSelector(state => state.streamCryptoInfo);  
  const { symbolLimit } = useSelector(state => state.globalData);

  const [topEntries, setTopEntries] = useState([]);
  const [bottomEntries, setBottomEntries] = useState([]);

  const getPercentageChange = useCallback((symbol) => {
    if (initialPrices[symbol] === null || prices[symbol] === null) {
      return null;
    }
    const initialPrice = parseFloat(initialPrices[symbol]);
    const currentPrice = parseFloat(prices[symbol]);    
    const percentageChange = ((currentPrice - initialPrice) / initialPrice) * 100;
    return percentageChange.toFixed(2);
  }, [initialPrices, prices]);    

  useEffect(() => {
    if (prices && initialPrices) {
        const symbols = Object.keys(prices).slice(0, symbolLimit);
        const percentageChanges = symbols
            .map(symbol => ({
                symbol,
                percentageChange: getPercentageChange(symbol)
            }))
            .filter(item => item.percentageChange !== null);

        percentageChanges.sort((a, b) => b.percentageChange - a.percentageChange);

        setTopEntries(percentageChanges.slice(0, 50));
        setBottomEntries(percentageChanges.slice(-50).reverse());
    }
  }, [prices, initialPrices, getPercentageChange, symbolLimit]);

  return (
    <>
    {!finishedLoad && <Spinner title="" color="#0e440d" /> }
    {topEntries.length > 0 && bottomEntries.length > 0 && finishedLoad && (
      <div style={{ display: 'flex', textAlign: 'left' }}>
        <fieldset className='fieldset' style={{ width: '50%', height: '100%', marginRight: '10px' }}>
          <legend style={{ color: '#6ac46b' }} className='legend'>Best Performances</legend>
          <table style={{ width: '100%', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
            <tbody>
              {topEntries.map(entry => (
                <tr style={{ borderBottom: '1px solid #525252' }} key={entry.symbol}>
                  <td style={{ width: '20%' }}>
                    <img
                      src={symbolIcons[entry.symbol]}
                      alt=""
                      style={{ width: '40px', marginRight: '10px', borderRadius: '50%' }}
                    />
                  </td>
                  <td style={{ width: '40%', fontSize:'15pt' }}>{entry.symbol.slice(0,-4)}</td>
                  <td style={{ width: '40%', fontSize:'15pt', color: entry.percentageChange > 0 ? '#6ac46a' : '#ec8282' }}>{entry.percentageChange}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </fieldset>
    
        <fieldset className='fieldset' style={{  width: '50%', height: '100%' }}>
          <legend style={{ color: '#e17d7c' }} className='legend'>Worst Performances</legend>
          <table style={{ width: '100%', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
            <tbody>
              {bottomEntries.map(entry => (
                <tr style={{ borderBottom: '1px solid #525252' }} key={entry.symbol}>
                  <td style={{ width: '20%' }}>
                    <img
                      src={symbolIcons[entry.symbol]}
                      alt=""
                      style={{ width: '40px', marginRight: '10px', borderRadius: '50%' }}
                    />
                  </td>
                  <td style={{ width: '40%', fontSize:'15pt' }}>{entry.symbol.slice(0,-4)}</td>
                  <td style={{ width: '40%', fontSize:'15pt', color: entry.percentageChange > 0 ? '#6ac46a' : '#ec8282' }}>{entry.percentageChange}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </fieldset>    
      </div>
    )}</>
  );
};

export default BuySellTrends;